export var LeaderboardItemType;
(function (LeaderboardItemType) {
    LeaderboardItemType[LeaderboardItemType["Name"] = 1] = "Name";
    LeaderboardItemType[LeaderboardItemType["TotalBets"] = 2] = "TotalBets";
    LeaderboardItemType[LeaderboardItemType["PlayerId"] = 3] = "PlayerId";
    LeaderboardItemType[LeaderboardItemType["WonStake"] = 4] = "WonStake";
    LeaderboardItemType[LeaderboardItemType["AcceptedBet"] = 5] = "AcceptedBet";
    LeaderboardItemType[LeaderboardItemType["Rank"] = 6] = "Rank";
    LeaderboardItemType[LeaderboardItemType["WhlCode"] = 7] = "WhlCode";
    LeaderboardItemType[LeaderboardItemType["Uid"] = 8] = "Uid";
})(LeaderboardItemType || (LeaderboardItemType = {}));
